import React from 'react';

import { useAsyncProcess } from 'hooks/useAsyncProcess';
import { useAppState } from 'hooks/useAppState';
import { useAppDispatcher } from 'hooks/useAppDispatcher';

// TODO: разделить на отдельные процессы
export const usePartnerClientManagerProcess = () => {
  const { partnerClientManager } = useAppState();

  const {
    clientId,
    clientInvalidated,
    notesTextInvalidated,
    monthReportsInvalidated,
  } = partnerClientManager;

  const dispatch = useAppDispatcher();

  const startProcess = useAsyncProcess();

  React.useLayoutEffect(() => {
    if (clientInvalidated) {
      return startProcess((metods) =>
        metods.getPartnerClient(clientId).then((client) => {
          dispatch({
            name: 'PartnerClientManager__ClientRecieved',
            client,
          });
        })
      );
    }
  }, [clientId, clientInvalidated, dispatch, startProcess]);

  React.useLayoutEffect(() => {
    if (notesTextInvalidated) {
      return startProcess((metods) =>
        metods.getPartnerClientNotes(clientId).then((notesText) => {
          dispatch({
            name: 'PartnerClientManager__NotesTextRecieved',
            value: notesText,
          });
        })
      );
    }
  }, [clientId, dispatch, notesTextInvalidated, startProcess]);

  React.useLayoutEffect(() => {
    if (monthReportsInvalidated) {
      return startProcess((metods) =>
        metods.getPartnerClientMonthReports(clientId).then((monthReports) => {
          dispatch({
            name: 'PartnerClientManager__MonthReportsRecieved',
            monthReports,
          });
        })
      );
    }
  }, [clientId, dispatch, monthReportsInvalidated, startProcess]);
};
